export function formatPercent(value) {
  return `${value}%`
}
